<template>
  <div>
    <new-ol-map-base
      ref="mapBase"
      :layers="conservationLayers"
      :location="location"
      :searchResult="searchResult"
      @onMapReady="onMapReady($event)"
      @mapPointerMove="onPointerMove($event)"
      @mapClick="onClick($event)"
    >
    </new-ol-map-base>
    <tooltip-card-map-conservation
      v-show="map"
      :tooltipParams="tooltipParams"
      :overlayLayerTooltipCard="overlayLayerTooltipCard"
    ></tooltip-card-map-conservation>
  </div>
</template>

<script>
import "ol/ol.css";
import VectorSource from 'ol/source/Vector';
import GeoJSON from "ol/format/GeoJSON";
import { TileWMS } from "ol/source";
import {getTooltipPropertiesOfLayer, getTooltipPropertiesFromFeature, initHighlightStyle } from '@/ol-maps/functions';
import {getSublayers, getDataFeatures, addOverlayMap} from '@/ol-maps/factory';
import NewOlMapBase from '../common/NewOlMapBase';
import {getSubLayerByProperty} from '../../ol-maps/functions';
import TooltipCardMapConservation from "./TooltipCardMapConservation";
export default {
  name: "ConservationMap",
  props:['searchResult','location'],
  components:{TooltipCardMapConservation, NewOlMapBase},
  data: () => ({
    view: undefined,
    map: undefined,
    overlaysGroup: [],
    overlayTooltipText: undefined,
    overlayLayerTooltip: undefined,
    tooltipParams:[],
    flag: undefined,
    overlayLayerTooltipCard: undefined,
    featureOverlay: undefined,
    initializedLocation: false
  }),
  watch:{
    location(){
      this.changeLayerLocationIdProperty();
    }
  },
  computed: {
    conservationLayers () {
      return this.$store.getters.conservationLayers;
    },
  },
  created () {
    this.initialize()
  },
  methods: {
    async initialize(){
      await this.$store.dispatch('loadConservationLayers');
      this.overlaysGroup = await getSublayers(this.conservationLayers);
      if (this.$refs.mapBase) {
        this.$refs.mapBase.initialize();
      }
    },
    onMapReady(value){
      const {map, view} = value;
      this.map = map;
      this.view = view;
      this.addTooltipOverlay();
      if(!this.initializedLocation){
        this.changeLayerLocationIdProperty();
      }
    },

    async onPointerMove(e){
      const me = this;
      this.flag = e.pixel

      if(this.featureOverlay){
        this.featureOverlay.getSource().clear(true);
      }

      await new Promise(r => setTimeout(r, 100));
      if(this.flag != e.pixel){
        return;
      }
      this.flag = undefined
      let pixel = me.map.getEventPixel(e.originalEvent);
      me.clearTooltipParams();
      // eslint-disable-next-line no-unused-vars
      me.map.forEachLayerAtPixel(pixel, function (layer, r) {
        const source = layer.getSource();
        const propertiesLayer = layer.getProperties();
        if(source instanceof TileWMS && propertiesLayer.tooltip_params && !propertiesLayer.hide_on_menu){
          const view = me.map.getView();
          const fetchData = async () => {
            const features = await getDataFeatures(e, source, view);
            // highlightStyle

            let feature = features[0];
            if(feature && propertiesLayer){
              if(propertiesLayer.property_params){
                if(propertiesLayer.property_params.highlightOnHoverFeature){
                  const show_highlights = propertiesLayer.property_params.highlightOnHoverFeature;

                  const vectorSource = new VectorSource({
                    features: (new GeoJSON().readFeatures(feature))
                  });

                  if (show_highlights) {
                    const { fillColor, strokeColor } = show_highlights;
                    if(me.featureOverlay){
                       me.featureOverlay.getSource().clear(true);
                    }
                    me.featureOverlay = initHighlightStyle(me.map, fillColor, strokeColor);
                    me.featureOverlay.setSource(vectorSource);
                  }
                }
              }
            }
            // highlightStyle
            document.getElementById('map').style.cursor = 'pointer';// map cursor style
            if(features && features.length > 0) {
              const {keys, icon_params} = getTooltipPropertiesOfLayer(propertiesLayer);
              features.forEach(feature_properties => {
                me.addTooltipParams(
                  {
                    ...getTooltipPropertiesFromFeature(keys, feature_properties.properties),
                    idLayer: propertiesLayer.id,
                    name: propertiesLayer.name,
                    zindex: propertiesLayer.property_params.zindex,
                    updatedAt: feature_properties.properties.date ?? feature_properties.properties.date,
                    icon_params: propertiesLayer.icon_params ? propertiesLayer.icon_params  : icon_params
                  }
                );
              });
              me.overlayLayerTooltipCard.setPosition(e.coordinate);
            }
          }
          fetchData();
        } else {
          document.getElementById('map').style.cursor = '';// map cursor style
          //this.featureOverlay.getSource().clear(true);
        }
      });

      // if(this.tooltipParams.length === 0){
      //  me.overlayLayerTooltipCard.setPosition(undefined);
      // }
    },
    async onClick(e){
      const me = this;

      // force clear tooltips by click
      me.overlayLayerTooltipCard.setPosition(undefined);

      // eslint-disable-next-line no-unused-vars
      me.map.forEachLayerAtPixel(e.pixel, function (layer, r) {
        const source = layer.getSource();
        const propertiesLayer = layer.getProperties();
        if(propertiesLayer.event_params){
          if(propertiesLayer.event_params.type === 'click'){
            const fetchData = async () => {
              const view = me.map.getView();
              const features = await getDataFeatures(e, source, view);
              if (features && features.length > 0) {
                const feature_properties = features[0];
                me.emitClick(feature_properties);
              }
            }
            fetchData();
          }
        }
      });

    },
    emitClick(feature_properties){
      const {properties} = feature_properties;
      if(properties){
        if(properties.rcplocationref){
          //this.dialog = true
          this.$emit('idClick', properties.rcplocationref)
        } else if(properties.sbsid) {
          //this.dialog = true
          this.$emit('idClick', properties.sbsid);
        }
      }
    },
    addTooltipOverlay(){
      const tooltipCard = document.getElementById("tooltip-card");
      this.overlayLayerTooltipCard = addOverlayMap(this.map, tooltipCard, 'bottom-center');
    },
    addTooltipParams(params){
      this.tooltipParams.push(params);
    },
    clearTooltipParams(){
      this.tooltipParams = [];
    },
    changeLayerLocationIdProperty(){
      if(this.map && this.location){
        this.initializedLocation = true;
        const sublayer = getSubLayerByProperty(this.map, 'id', 733);

        if(sublayer){
          const source = sublayer.getSource();
          const params = source.getParams();
          source.updateParams({...params, VIEWPARAMS: `locationid:${this.location.locationid}`});
        }
      }
    }
  },
}
</script>

<style scoped>
</style>
